module.exports = __webpack_public_path__ + "media/images/official/special_workcation_04-7aaaeb697275bfad5d552080ff315343.jpg";